export function randomColor () {
  return '#' + generateValue() + generateValue() + generateValue() + 'FF'
}

function generateValue (): String {
  const rd = Math.floor(Math.random() * 255).toString(16).toUpperCase()
  return rd.length === 1 ? '0' + rd : rd
}
